const classes = {
  hide: "hide",
  active: "active",
  sellingPlanSelected: "selling-plan-group-selected"
};

let lastFocusedElement,
  handleFocusTrapRef,
  cachedData = {},
  cachedModalData = {};

// Event delegation for form changes (variant selection)
document.addEventListener("change", function (event) {
  const form = event.target.closest("[data-product-form]");

  if (form) {
    const section = form.closest(`[data-section-type]`);
    if (!section) {
      return;
    }
    const target = getInputForEventTarget(event.target);

    if (target.hasAttribute("data-product-url")) {
      if (target.hasAttribute("data-option-value-id")) {
        section.currentVariant = getVariantData(section, target.id);
      }
      onVariantChange(section, { target });
    }
  }
});

// Event delegation for subscription plan clicks
document.addEventListener("click", onSubscriptionClick);

// Handle initial load for sections (either on page load or after dynamic content injection)
function onInitialLoad(section) {
  updateOptions(section);
  updateMasterIds(section);
  setupPlusMinusControls(section);
  autoSelectSellingPlan(section);
  renderedCallback(section);
}

function renderedCallback(section) {
  var subscriptions = document.getElementById(
    "select-subscription-" + section.dataset.sectionId
  );
  if (subscriptions) {
    updateURL(section, section.currentVariant, section.currentSellingPlan);
  } else {
    updateURL(section, section.currentVariant);
  }

  startGalleryViewer(section);
}

// Function to fetch variant data from the section
function getVariantData(section, inputId) {
  return JSON.parse(getVariantDataElement(section, inputId).textContent);
}

function getVariantDataElement(section, inputId) {
  return section.querySelector(
    `script[type="application/json"][data-resource="${inputId}"]`
  );
}

// Get the first available variant
function getFirstAvailableVariantData(section) {
  return JSON.parse(
    section.querySelector("[data-first-available-variant-json]").textContent
  );
}

// Get the initially selected variant
function getSelectedVariant(section) {
  return JSON.parse(
    section.querySelector("[data-selected-variant]").textContent
  );
}

// Helper function to get input target
function getInputForEventTarget(target) {
  return target.tagName === "SELECT" ? target.selectedOptions[0] : target;
}

// Variant change handler
function onVariantChange(section, { target: optionValueElement }) {
  section.dataset.requestUrl = optionValueElement.dataset.productUrl;

  updateOptions(section);
  updateMasterIds(section);

  if (section.currentVariant) {
    updateVariantInput(section);
    renderProductInfo(section, optionValueElement);
  }
}

// Subscription click handler
function onSubscriptionClick(event) {
  const section = event.target.closest("[data-section-type]");
  if (!section) {
    return;
  }

  const sellingPlans = section.querySelector(
    `#select-subscription-${section.dataset.sectionId}`
  );
  const sellingPlanAddButton = event.target.closest("[data-add-selling-plan]");
  const sellingPlanRemoveButton = event.target.closest(
    "[data-remove-selling-plan]"
  );

  if (!sellingPlanAddButton && !sellingPlanRemoveButton) {
    return;
  }

  event.preventDefault();

  const sellingPlanGroup = sellingPlans.querySelector(
    "[data-selling-plan-group]"
  );
  const sellingPlanSelect = sellingPlans.querySelector(
    "[data-selling-plan-select]"
  );

  const sellingPlanId =
    section.firstAvailableOrCurrentSellingPlan.selling_plan_id;

  if (sellingPlanGroup && sellingPlanSelect) {
    if (sellingPlanRemoveButton) {
      section.removeAttribute("data-selling-plan");
      sellingPlanGroup.classList.remove(classes.sellingPlanSelected);
      sellingPlanSelect.value = "";
      sessionStorage.setItem(sellingPlanId, "removed");
      updateURL(section, section.currentVariant, "delete");
    } else if (sellingPlanAddButton) {
      section.dataset.sellingPlan = sellingPlanId;
      sellingPlanGroup.classList.add(classes.sellingPlanSelected);
      sellingPlanSelect.value = sellingPlanId;
      sessionStorage.setItem(sellingPlanId, "added");
      updateURL(
        section,
        section.currentVariant,
        section.firstAvailableOrCurrentSellingPlan
      );
    }
    updateOptions(section);
    updateMasterIds(section);
    renderProductInfo(section);
  }
}

// Function to update options and variants
function updateOptions(section) {
  section.firstSelectedOption = section.querySelector(
    ".product-option-group input:checked"
  );

  section.sellingPlanSelectedOption = Array.from(
    section.querySelectorAll('[name="selling_plan"]'),
    function (select) {
      return parseInt(select.value);
    }
  );
}

function updateMasterIds(section) {
  if (!section.currentVariant) {
    if (section.firstSelectedOption != null) {
      section.currentVariant = getVariantData(
        section,
        section.firstSelectedOption.id
      );
    } else {
      section.currentVariant = getFirstAvailableVariantData(section);
    }
  }
  if (!section.currentVariant) {
    return;
  }
  section.dataset.currentVariant = section.currentVariant.id;

  section.currentSellingPlan =
    section.currentVariant.selling_plan_allocations.find(function (
      selling_plan_allocation
    ) {
      return (
        selling_plan_allocation.selling_plan_id ===
        section.sellingPlanSelectedOption[0]
      );
    });

  if (!section.currentSellingPlan) {
    section.firstAvailableOrCurrentSellingPlan =
      section.currentVariant.selling_plan_allocations[0];
  } else {
    section.firstAvailableOrCurrentSellingPlan = section.currentSellingPlan;
  }
}

// Function to update the variant input field
function updateVariantInput(section) {
  const productSelect = section.querySelector("[data-product-select]");
  if (!productSelect || !section.currentVariant) {
    return;
  }

  productSelect.value = section.currentVariant.id;
}

function setupPlusMinusControls(section) {
  section.querySelectorAll(".plus-minus-control").forEach(function (control) {
    const input = control.querySelector('input[name="quantity"]');
    const hiddenInputs = control.querySelectorAll(
      'input[name^="items"][name$="[quantity]"]'
    );
    const incrementButton = control.querySelector(".increment-button");
    const decrementButton = control.querySelector(".decrement-button");

    // Function to synchronize hidden inputs with visible quantity input
    function syncHiddenInputs() {
      if (hiddenInputs.length === 0) {
        return; // Exit if no hidden inputs are found
      }
      hiddenInputs.forEach((hiddenInput) => {
        hiddenInput.value = input.value;
      });
    }

    // Increment quantity
    incrementButton.addEventListener("click", function () {
      const currentValue = parseInt(input.value, 10);
      const max = input.getAttribute("max")
        ? parseInt(input.getAttribute("max"), 10)
        : Infinity;

      if (currentValue < max) {
        input.value = currentValue + 1;
        syncHiddenInputs(); // Update hidden inputs
      }
    });

    // Decrement quantity
    decrementButton.addEventListener("click", function () {
      const currentValue = parseInt(input.value, 10);
      const min = input.getAttribute("min")
        ? parseInt(input.getAttribute("min"), 10)
        : 1;

      if (currentValue > min) {
        input.value = currentValue - 1;
        syncHiddenInputs(); // Update hidden inputs
      }
    });

    // Sync hidden inputs on manual input change
    input.addEventListener("input", function () {
      syncHiddenInputs();
    });
  });
}

let defaultImgId = null;
const altImgClass = "alt-image-selected";

function startGalleryViewer(section) {
  const galleryContainer = section.querySelector(".product-image");
  if (!galleryContainer) {
    return;
  }
  galleryContainer.classList.remove(altImgClass);
  const thumbnails = galleryContainer.querySelectorAll(
    ".image-gallery-thumbs button"
  );
  const images = galleryContainer.querySelectorAll(
    ".image-gallery [data-product-image-id]"
  );
  const updateFeaturedImage = (targetId) => {
    let isDefaultImgSelected = false;
    images.forEach((image) => {
      if (image.id === targetId) {
        image.style.removeProperty("display");
        image.classList.remove(classes.hide);
        if (image.id === defaultImgId) {
          isDefaultImgSelected = true;
        }
      } else {
        image.classList.add(classes.hide);
      }
    });
    if (isDefaultImgSelected) {
      galleryContainer.classList.remove(altImgClass);
    } else {
      galleryContainer.classList.add(altImgClass);
    }
  };

  thumbnails.forEach((thumbnail) => {
    thumbnail.addEventListener("click", function () {
      updateFeaturedImage(thumbnail.dataset.target);
      thumbnails.forEach((thumbnail) => {
        thumbnail.classList.remove(classes.active);
      });
      thumbnail.classList.add(classes.active);
    });
  });

  // Initial setup to check which image is not hidden and set it as default
  images.forEach((image) => {
    if (!image.classList.contains("hide")) {
      defaultImgId = image.id;
    }
  });
}

// Function to render updated product information
function renderProductInfo(section, target) {
  const productUrl = section.dataset.requestUrl || section.dataset.url;
  const shouldFetchFullPage = section.dataset.url !== productUrl;
  const params = [];
  const requestedVariantId = section.currentVariant.id;
  let cacheDataId = requestedVariantId;

  params.push(`variant=${requestedVariantId}`);
  if (section.currentSellingPlan) {
    const requestedSellingPlanId = section.currentSellingPlan.selling_plan_id;
    cacheDataId = `${requestedVariantId}_${requestedSellingPlanId}`;
    params.push(`selling_plan=${requestedSellingPlanId}`);
  }

  if (cachedData[cacheDataId]) {
    handleUpdateProductInfo(cachedData[cacheDataId], section);
    return renderedCallback(section);
  }

  if (!shouldFetchFullPage) {
    params.push(`section_id=${section.dataset.sectionId}`);
  }

  const fetchUrl = `${productUrl}?${params.join("&")}`;
  section.classList.add("loading");

  fetch(fetchUrl)
    .then((response) => response.text())
    .then((responseText) => {
      if (section.currentVariant.id !== requestedVariantId) {
        return;
      }

      const html = new DOMParser().parseFromString(responseText, "text/html");

      if (shouldFetchFullPage) {
        handleSwapProduct(html);
      } else {
        cachedData[cacheDataId] = html;
        handleUpdateProductInfo(html, section);
      }
    })
    .finally(() => {
      section.classList.remove("loading");
      if (target && target.id) {
        document.querySelector(`#${target.id}`)?.focus();
      }
      return renderedCallback(section);
    });
}

// Example function to update product information in the section
function handleUpdateProductInfo(html, section) {
  const updateSourceFromDestination = function (id) {
    const source = html.getElementById(`${id}-${section.dataset.sectionId}`);
    const destination = section.querySelector(
      `#${id}-${section.dataset.sectionId}`
    );
    if (source && destination) {
      destination.innerHTML = source.innerHTML;
    }
  };
  updateSourceFromDestination("purchase-summary");
  updateSourceFromDestination("select-subscription");
  updateSourceFromDestination("product-image");
  updateSourceFromDestination("quantity-lock");
  updateSourceFromDestination("quick-add-header");
}

// Utility function to auto-select the selling plan
function autoSelectSellingPlan(section) {
  if (section.dataset.sellingPlan) {
    return;
  }

  const sellingPlanGroup = section.querySelector("[data-selling-plan-group]");
  const sellingPlanSelect = section.querySelector("[data-selling-plan-select]");

  if (!sellingPlanGroup || !sellingPlanSelect) {
    return;
  }

  const sellingPlanId =
    section.firstAvailableOrCurrentSellingPlan.selling_plan_id;
  const sellingPlanStatus = sessionStorage.getItem(sellingPlanId);

  if (sellingPlanGroup && sellingPlanStatus !== "removed") {
    sellingPlanGroup.classList.add(classes.sellingPlanSelected);
    section.dataset.sellingPlan = sellingPlanId;
    sellingPlanSelect.value = sellingPlanId;

    updateOptions(section);
    updateMasterIds(section);
    renderProductInfo(section);
  }
}

// Function to update the URL with the selected variant and selling plan
function updateURL(section, variant, sellingPlan) {
  if (section.dataset.updateUrl === "false") return;
  if (!variant) return;

  let searchParams = window.location.search;
  const params = {};

  if (variant) {
    params.variant = variant.id;
  }

  if (sellingPlan) {
    if (sellingPlan === "delete") {
      searchParams = getUrlwithNewSearchParams(
        searchParams,
        "delete",
        "selling_plan"
      );
    } else {
      params.selling_plan = sellingPlan.selling_plan_id;
    }
  }

  searchParams = getUrlwithNewSearchParams(searchParams, "set", params);

  let baseUrl = section.dataset.url;
  if (section.dataset.requestUrl) {
    baseUrl = section.dataset.requestUrl;
  }

  const url = `${baseUrl}?${searchParams.toString()}`;
  window.history.replaceState({ path: url }, "", url);
}

// Helper function to modify search parameters
function getUrlwithNewSearchParams(URLsearchParams, action, params) {
  const searchParams = new URLSearchParams(URLsearchParams);
  if (action === "set") {
    for (const key in params) {
      searchParams.set(key, params[key]);
    }
  } else if (action === "delete") {
    searchParams.delete(params);
  }
  return searchParams;
}

function openModal() {
  const modal = document.getElementById("modal");
  const section = modal.querySelector("[data-section-type]");
  if (section) {
    onInitialLoad(section);
  }
  lastFocusedElement = document.activeElement;
  modal.style.display = "block";
  modal.setAttribute("aria-hidden", "false");
  trapFocus(modal);

  setTimeout(function () {
    document.documentElement.classList.add("modal-active");
  }, 100);
}

function closeModal() {
  const openModal = document.querySelector(".modal-active #modal");
  if (openModal) {
    openModal.style.display = "none";
    openModal.setAttribute("aria-hidden", "true");
    openModal.removeAttribute("data-modal-type");
    openModal.removeAttribute("data-modal-id");
    document.documentElement.classList.remove("modal-active");
    const modalBody = openModal.querySelector(".modal-body");
    if (modalBody) {
      modalBody.innerHTML = "";
    }
    releaseFocus(openModal);
  }
}

function trapFocus(modal) {
  const focusableElements = modal.querySelectorAll(
    'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
  );
  const firstFocusableElement = focusableElements[0];
  const lastFocusableElement = focusableElements[focusableElements.length - 1];

  handleFocusTrapRef = function handleFocusTrap(e) {
    if (e.key === "Tab") {
      // If shift + Tab (backward)
      if (e.shiftKey) {
        if (document.activeElement === firstFocusableElement) {
          e.preventDefault();
          lastFocusableElement.focus();
        }
      }
      // If Tab (forward)
      else {
        if (document.activeElement === lastFocusableElement) {
          e.preventDefault();
          firstFocusableElement.focus();
        }
      }
    } else if (e.key === "Escape") {
      closeModal(modal);
    }
  };

  modal.addEventListener("keydown", handleFocusTrapRef);
  firstFocusableElement.focus(); // Focus the first element when modal is opened
}

function releaseFocus(modal) {
  // Remove the event listener for focus trapping
  modal.removeEventListener("keydown", handleFocusTrapRef);

  // restore focus to the element that opened the modal
  if (lastFocusedElement) {
    lastFocusedElement.focus();
  }
}

document.addEventListener("DOMContentLoaded", function () {
  // Quick Add Button Logic with Caching
  document.addEventListener("click", function (event) {
    const button = event.target.closest("[data-quick-add]");

    if (!button) {
      return;
    }

    const baseUrl = button.getAttribute("data-quick-add");
    const separator = baseUrl.includes("?") ? "&" : "?";
    const fetchUrl = baseUrl + separator + "sections=product-quick-add";
    const modalId = fetchUrl; // Use URL as the cache key
    const modal = document.querySelector("#modal");
    const destination = modal.querySelector(".modal-body");

    // Check if the data is already cached
    if (cachedModalData[modalId]) {
      // Use cached data
      modal.dataset.modalId = "";
      modal.dataset.modalType = "quick-add";
      destination.innerHTML = cachedModalData[modalId];
      openModal();
      return;
    }

    button.classList.add("is-adding");

    // Fetch the section content
    fetch(fetchUrl)
      .then(function (response) {
        return response.json();
      })
      .then(function (responseData) {
        var source = responseData["product-quick-add"];
        if (source && destination) {
          // Cache the fetched content
          cachedModalData[modalId] = source;

          // Set the content and open the modal
          modal.dataset.modalId = "";
          modal.dataset.modalType = "quick-add";
          destination.innerHTML = source;
        } else {
          console.error(
            "Failed to find source or destination element for modal."
          );
        }
      })
      .catch(function (error) {
        console.error("Error loading the modal content:", error);
      })
      .finally(function () {
        button.classList.remove("is-adding");
        openModal();
      });
  });

  // Modal Button Logic with Caching
  document.addEventListener("click", function (event) {
    const button = event.target.closest("[data-modal]");

    if (!button) {
      return;
    }

    const fetchUrl = "?sections=content-modal";
    const dataModal = button.getAttribute("data-modal");
    const modalId = fetchUrl + "#" + dataModal; // Unique cache key for this modal content
    const modal = document.querySelector("#modal");
    const destination = modal.querySelector(".modal-body");

    // Check if the data is already cached
    if (cachedModalData[modalId]) {
      modal.dataset.modalId = dataModal;
      modal.dataset.modalType = "content";
      // Use cached data
      destination.innerHTML = cachedModalData[modalId];
      openModal();
      return;
    }

    button.classList.add("is-adding");

    // Fetch the section content
    fetch(fetchUrl)
      .then(function (response) {
        return response.json();
      })
      .then(function (responseData) {
        var html = responseData["content-modal"];
        var parser = new DOMParser();
        var parsedDocument = parser.parseFromString(html, "text/html");
        var source = parsedDocument.querySelector(`#${dataModal}`);

        if (source && destination) {
          // Cache the fetched content
          cachedModalData[modalId] = source.innerHTML;

          // Set the content and open the modal
          modal.dataset.modalId = dataModal;
          modal.dataset.modalType = "content";
          destination.innerHTML = source.innerHTML;
        } else {
          console.error(
            "Failed to find source or destination element for modal."
          );
        }
      })
      .catch(function (error) {
        console.error("Error loading the modal content:", error);
      })
      .finally(function () {
        button.classList.remove("is-adding");
        openModal();
      });
  });

  // Close modal on click outside or when pressing escape
  document.getElementById("modal").addEventListener("click", function (e) {
    if (e.target === this || e.target.classList.contains("close")) {
      closeModal();
    }
  });

  // Initialization for all sections on page load
  document.querySelectorAll("[data-section-type]").forEach(function (section) {
    onInitialLoad(section);
  });
});
window.addEventListener("cartNotification.open", function (e) {
  closeModal();
});
